import {
  GridColumnMenuProps,
  ColumnMenuPropsOverrides,
  GridColumnMenu,
  GridColumnMenuItemProps,
} from "@mui/x-data-grid-pro";

export const CustomColumnMenu = (
  props: GridColumnMenuProps &
    ColumnMenuPropsOverrides & {
      customfilteritem: React.MemoExoticComponent<(props: GridColumnMenuItemProps) => JSX.Element>;
    }
): JSX.Element => {
  if (props.customizedcolumns.includes(props.colDef.field)) {
    return (
      <GridColumnMenu
        {...props}
        slots={{
          // columnMenuColumnsItem: null,
          // columnMenuSortItem: null,
          columnMenuAggregationItem: null,
          columnMenuGroupingItem: null,
          columnMenuPinningItem: null,
          columnMenuFilterItem: props.customfilteritem,
        }}
      />
    );
  }

  return <GridColumnMenu {...props} />;
};
